import type { SuretyAccountId } from "@inrev/common";
import { ProcessingBanner } from "@portal/components/features/banners";
import { usePendingExtractions } from "@portal/components/financials/hooks/useHasPendingExtractions";
import { FC } from "react";

export type AdminAccountProcessingBannerProps = { accountId: SuretyAccountId };

function processingCopy(hasPendingFinancial: boolean, hasPendingWip: boolean) {
	if (hasPendingFinancial && hasPendingWip) {
		return {
			title: "Analyzing Financial and WIP Data",
			description:
				"Financial and work-in-progress data are being extracted. The review will complete automatically once processing is finished.",
		};
	}
	if (hasPendingWip) {
		return {
			title: "Analyzing WIP Data",
			description:
				"Work-in-progress data is being extracted. The review will complete automatically once processing is finished.",
		};
	}
	return {
		title: "Analyzing Financial Data",
		description:
			"Financial data is being extracted. The review will complete automatically once processing is finished.",
	};
}

export const AdminAccountProcessingBanner: FC<AdminAccountProcessingBannerProps> = ({
	accountId,
}) => {
	const { hasPendingFinancial, hasPendingWip, hasPendingExtractions } =
		usePendingExtractions(accountId);

	if (!hasPendingExtractions) {
		return null;
	}

	const { title, description } = processingCopy(hasPendingFinancial, hasPendingWip);

	return (
		<ProcessingBanner
			testId="admin-account-processing-banner"
			title={title}
			description={description}
		/>
	);
};
